import { render, staticRenderFns } from "./Evaluate.vue?vue&type=template&id=7d4a464c&scoped=true"
import script from "./Evaluate.vue?vue&type=script&lang=js"
export * from "./Evaluate.vue?vue&type=script&lang=js"
import style0 from "./Evaluate.vue?vue&type=style&index=0&id=7d4a464c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d4a464c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d4a464c')) {
      api.createRecord('7d4a464c', component.options)
    } else {
      api.reload('7d4a464c', component.options)
    }
    module.hot.accept("./Evaluate.vue?vue&type=template&id=7d4a464c&scoped=true", function () {
      api.rerender('7d4a464c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/studentquality/Evaluate.vue"
export default component.exports